// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"css_wrapper__21rja","wrapper__text":"css_wrapper__text__zngZ6","cancel-link":"css_cancel-link__3PFyt"};